const getSiteSubsidiary = (subsidiaries) => {
  const sites = new Set();
  const siteTotals = [];
  const refinedResult = subsidiaries.map((subsidiary) => {
    const refinedSubsidiary = { ...subsidiary };
    const { siteName, siteNumber, subsidiaryCompanyName } = refinedSubsidiary;
    if (!sites.has(siteNumber)) {
      sites.add(siteNumber);
      siteTotals.push({
        siteNumber,
        siteName,
        subsidiaryCompanyName: '전체',
        subsidiaryCompanyCode: '',
        itemLabel: `${siteName} > 전체`,
      });
    }
    refinedSubsidiary.itemLabel = `${siteName} > ${subsidiaryCompanyName}`;
    return refinedSubsidiary;
  });

  return [...siteTotals, ...refinedResult];
};

export { getSiteSubsidiary };
